var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isWsReady
    ? _c(
        "form",
        {
          class: _vm.classes,
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSendMessage.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "chat-input-wrapper" },
            [
              _c(
                "label",
                { staticClass: "chat-input-h", attrs: { for: "honeypot" } },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("chatbot.honeypot")) + "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.honeypot,
                    expression: "honeypot",
                  },
                ],
                staticClass: "chat-input-h",
                attrs: {
                  id: "honeypot",
                  "aria-hidden": "true",
                  tabindex: "-1",
                },
                domProps: { value: _vm.honeypot },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.honeypot = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "chat-input-label",
                  attrs: { for: "chatInput" },
                },
                [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]
              ),
              _vm._v(" "),
              _c("auto-height-input", {
                attrs: {
                  id: "chatInput",
                  disabled: !_vm.isChatInputEnabled,
                  type: _vm.inputType,
                  name: _vm.inputName,
                  autocomplete: _vm.autoComplete,
                  placeholder: _vm.placeholder,
                },
                on: {
                  submit: _vm.handleSendMessage,
                  invalid: _vm.handleFormInvalid,
                  focus: _vm.handleFocus,
                  blur: _vm.handleBlur,
                },
                model: {
                  value: _vm.textMessage,
                  callback: function ($$v) {
                    _vm.textMessage = $$v
                  },
                  expression: "textMessage",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "send-button",
              attrs: {
                id: "sendButton",
                type: "submit",
                "aria-label": _vm.$t("chatbot.send"),
                disabled: !_vm.isChatInputEnabled,
              },
            },
            [_c("button-icon")],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }